import { RecordMode } from '@/types/Base';
import { z } from 'zod';

export const material = z.object({
  id: z.string(),
  companyId: z.string(),
  code: z.string(),
  name: z.string(),
  materialTypeId: z.string(),
  vatCategoryId: z.string(),
  mwAccountGroupId: z.string(),
  motherCodeId: z.string(),
  smallCode: z.string().optional(),
  smallName: z.string().optional(),
  isActive: z.boolean(),
  sequence: z.number().optional(),
  securityStock: z.number().optional(),
  remarks: z.string().optional(),
  rowStatus: z.nativeEnum(RecordMode).optional(),
  createdDate: z.string().optional(),
  lastUpdate: z.string().optional(),
  createUserId: z.string().optional(),
  updateUserId: z.string().optional(),
  isFromManager: z.boolean().optional(),
  boid: z.string().optional(),
  exportedDate: z.string().optional(),
  deleted: z.boolean().optional(),
  rowVersion: z.string().optional(),
  colorCatalogId: z.string().optional(),
  sizeCatalogId: z.string().optional(),
  styleCatalogId: z.string().optional(),
});

export const getMaterialsWithConditionsSchema = z.array(material);

export type GetMaterialsWithConditionsResponse = z.infer<typeof getMaterialsWithConditionsSchema>;
